<template>
  <drr
    :id="ID"
    :x="parseInt(Left)"
    :y="parseInt(Top)"
    :w="parseInt(Width)"
    :h="parseInt(Height)"
    :angle="parseInt(Angle)"
    :aspectRatio="false"
    :z="0"
    :selectable="Enabled"
    v-on:resizestop="resize"
    v-on:dragstop="drag"
    v-on:rotatestop="rotate"
    :class="Classe + ' box'"
    :style="`z-index:${Index};`"
  >
    <p v-if="Titulo.length > 0" class="text-center white-text ">
      <b>{{ Titulo }} </b>
    </p>
  </drr>
</template>

<script>
import drr from "@minogin/vue-drag-resize-rotate";
export default {
  /* eslint no-console: ["error", { allow: ["info", "warn", "error"] }] */
  name: "Caixa",
  components: {
    drr
  },
  props: {
    ID: { type: String, default: "0" },
    Titulo: { type: String, default: null },
    Top: { type: String, default: "0" },
    Left: { type: String, default: "0" },
    Width: { type: String, default: "100" },
    Height: { type: String, default: "100" },
    Angle: { type: String, default: "0" },
    Index: { type: String, default: "1" },
    Classe: {
      type: String,
      default: "light-blue darken-4 "
    },
    Enabled: { type: Boolean, default: false }
  },
  data() {
    return {
      vWidth: { type: String, default: "100" },
      vHeight: { type: String, default: "100" }
    };
  },
  methods: {
    rotate(pos) {
      let id = this.ID;
      console.info(
        `ID: ${id} | ANGLE: ${pos.angle} | TOP: ${pos.y} | LEFT: ${pos.x} | HEIGTH: ${pos.h} | WIDTH: ${pos.w}`,
        "rotate"
      );
    },
    resize(pos) {
      this.vWidth = pos.w + "";
      this.vHeight = pos.h + "";
      let el = document.getElementById(`${this.ID}`);
      el.style.width = `${this.vWidth}px`;
      el.style.height = `${this.vHeight}px`;
      let id = this.ID;
      console.info(
        `ID: ${id} | HEIGHT: ${pos.h} | WIDTH: ${pos.w} | ANGLE: ${pos.angle}`,
        "resize"
      );
    },
    drag(pos) {
      let id = this.ID;
      console.info(
        `ID: ${id} | TOP: ${pos.y} | LEFT: ${pos.x} | ANGLE: ${pos.angle}`,
        "drag"
      );
    }
  },
  mounted() {}
};
</script>

<style>
.box {
  position: absolute;
  display: table;
}
.box p {
  text-align: center;
  vertical-align: middle;
  display: table-cell;
}
</style>
